// extracted by mini-css-extract-plugin
module.exports = {"v1qjg41g":"v1qjg41g"};